import React from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { AutoFetchButton } from '@core/Components/AutoFetchButton'
import { getBetLoopProfileFollowAccountsPaged } from '@core/Areas/BetLoop/helpers/api'

export const useAccountFollowListData = (
  listType: 'following' | 'followers',
  profileId?: string
) => {
  const isFollowing = listType === 'following'
  const { data, isLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: isFollowing
        ? [...queryKeys.betLoopAccountProfileFollowing, profileId]
        : [...queryKeys.betLoopAccountProfileFollowers, profileId],

      queryFn: ({ pageParam }: { pageParam: string | null }) =>
        getBetLoopProfileFollowAccountsPaged({ pageParam, accountId: profileId, isFollowing }),
      initialPageParam: null,

      getNextPageParam: lastPage => {
        if (!lastPage || lastPage.length < 25) return undefined
        return lastPage[lastPage.length - 1]?.id ?? undefined
      },

      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
    })

  const isEmptyState = data?.pages[0].length === 0
  const isFinalPage = data && data.pages[data.pages.length - 1].length < 25

  return {
    data,
    isLoading,
    refetch,
    isEmptyState,
    isRefetching,
    LoadMoreButton: () =>
      isFinalPage || isEmptyState ? null : (
        <AutoFetchButton onClick={fetchNextPage} isFetching={isFetchingNextPage} />
      ),
  }
}
